exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".booking.page .header{height:100px;margin-bottom:-100px;padding:0;border-bottom:1px solid #50d8f5;position:relative}.booking.page .header .logo{width:215px;height:56px;margin:-28px 0 0 -660px;background:url(\"/images/logo.png\") no-repeat;position:absolute;top:50%;left:50%}.booking.page .header h1{display:none}.booking.page .agenda.component{margin:10px 0}.booking.page .agenda.component .column{border-color:transparent}.booking.page .main{padding:39px 39px 49px;border:1px solid #dcf7fd}.booking.page .main h2{margin:0 0 35px;font-family:Georgia,serif;font-size:28px;font-weight:700;line-height:30px;text-align:center;color:#ffa619}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/booking/booking.less
 ** module id = 150
 ** module chunks = 0
 **/